(function () {
  'use strict';

  var API_BASE = 'https://custom-order-portal-production.up.railway.app';

  var configPromise = null;
  function getConfig() {
    if (!configPromise) {
      configPromise = fetch(API_BASE + '/api/tsd-custom/config')
        .then(function (r) {
          if (!r.ok) throw new Error('config fetch failed');
          return r.json();
        })
        .catch(function (err) {
          configPromise = null;
          throw err;
        });
    }
    return configPromise;
  }

  // Each product's fee product comes from its config entry's fee_handle
  // (mugs: customization-sublimation, tumblers: customization-sublimation-tumbler).
  // Variant id and price are read from the storefront; price there is in cents.
  var feeCache = {};
  function getFee(handle) {
    if (!feeCache[handle]) {
      feeCache[handle] = fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('fee product not found: ' + handle);
          return r.json();
        })
        .then(function (p) {
          var v = p.variants[0];
          return { variant_id: v.id, price: v.price / 100 };
        })
        .catch(function (err) {
          delete feeCache[handle];
          throw err;
        });
    }
    return feeCache[handle];
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  // ---------- Button + modal ----------

  var modalEl = null;

  function initButton() {
    var btn = document.getElementById('tsd-customize-btn');
    if (!btn || !window.TSD_CUSTOM_PRODUCT) return;
    btn.addEventListener('click', function () {
      openModal(window.TSD_CUSTOM_PRODUCT);
    });
  }

  function injectStyles() {
    if (document.getElementById('tsd-customize-styles')) return;
    var style = document.createElement('style');
    style.id = 'tsd-customize-styles';
    style.textContent =
      '#tsd-customize-modal{position:fixed;inset:0;z-index:10000;}' +
      '#tsd-customize-modal .tsd-customize__overlay{position:absolute;inset:0;background:rgba(0,0,0,.5);}' +
      '#tsd-customize-modal .tsd-customize__dialog{position:relative;max-width:560px;width:calc(100% - 2rem);max-height:calc(100vh - 4rem);overflow-y:auto;margin:2rem auto;background:#fff;border-radius:8px;padding:1.75rem;box-shadow:0 10px 40px rgba(0,0,0,.25);}' +
      '#tsd-customize-modal .tsd-customize__close{position:absolute;top:.75rem;right:.75rem;background:none;border:none;font-size:1.75rem;line-height:1;cursor:pointer;padding:.25rem .5rem;}' +
      '#tsd-customize-modal h2{margin:0 0 .5rem;font-size:1.25rem;}' +
      '#tsd-customize-modal .tsd-customize__intro{margin:0 0 .75rem;font-size:.9rem;color:#555;}' +
      '#tsd-customize-modal .tsd-customize__how-it-works{margin:0 0 1.25rem;padding-left:1.1rem;font-size:.85rem;color:#555;}' +
      '#tsd-customize-modal .tsd-customize__how-it-works li{margin-bottom:.35rem;}' +
      '#tsd-customize-modal .tsd-customize__how-it-works ul{margin:.35rem 0 0;padding-left:1.1rem;}' +
      '#tsd-customize-modal .tsd-customize__row{margin-bottom:1rem;}' +
      '#tsd-customize-modal label{display:block;font-weight:600;font-size:.85rem;margin-bottom:.3rem;}' +
      '#tsd-customize-modal input[type="text"],#tsd-customize-modal input[type="email"],#tsd-customize-modal input[type="tel"],#tsd-customize-modal input[type="number"],#tsd-customize-modal select,#tsd-customize-modal textarea{width:100%;box-sizing:border-box;padding:.55rem .65rem;border:1px solid #ccc;border-radius:4px;font-size:.9rem;}' +
      '#tsd-customize-modal .tsd-customize__hint{margin:.35rem 0 0;font-size:.78rem;color:#666;}' +
      '#tsd-customize-modal .tsd-customize__error{color:#b00020;font-size:.85rem;margin:0 0 1rem;}' +
      '#tsd-customize-modal .tsd-customize__warning{color:#8a5a00;font-size:.85rem;}' +
      '#tsd-customize-modal .tsd-customize__actions{text-align:right;}' +
      '#tsd-customize-modal .tsd-customize__success{text-align:center;}' +
      '#tsd-customize-modal .tsd-customize__success .button{display:inline-block;margin-top:.5rem;}' +
      'body.tsd-customize-open{overflow:hidden;}';
    document.head.appendChild(style);
  }

  function openModal(product) {
    injectStyles();
    getConfig()
      .then(function (config) {
        var pconf = config.products[product.sku];
        if (!pconf) {
          window.alert('This product is not currently available for customization.');
          return;
        }
        return getFee(pconf.fee_handle).then(function (fee) {
          renderModal(product, config, fee);
        });
      })
      .catch(function () {
        window.alert('Sorry, the customization form could not be loaded right now. Please try again in a moment.');
      });
  }

  function closeModal() {
    if (modalEl) {
      modalEl.remove();
      modalEl = null;
      document.body.classList.remove('tsd-customize-open');
    }
  }

  function renderModal(product, config, fee) {
    closeModal();
    var pconf = config.products[product.sku];
    var unitsPerQty = pconf.units_per_qty;
    var isCase = unitsPerQty > 1;
    var acceptAttr = config.allowed_extensions
      .map(function (e) {
        return '.' + e;
      })
      .join(',');

    modalEl = document.createElement('div');
    modalEl.id = 'tsd-customize-modal';
    modalEl.innerHTML = [
      '<div class="tsd-customize__overlay"></div>',
      '<div class="tsd-customize__dialog" role="dialog" aria-modal="true" aria-labelledby="tsd-customize-title">',
      '<button type="button" class="tsd-customize__close" aria-label="Close">&times;</button>',
      '<h2 id="tsd-customize-title">Let Us Customize It</h2>',
      '<p class="tsd-customize__intro">Tell us how you’d like ' +
        escapeHtml(product.title) +
        ' customized.</p>',
      '<ul class="tsd-customize__how-it-works">' +
        '<li>Our graphics team creates mockups for your approval before printing.</li>' +
        '<li>You will receive an email to review your mockups and request edits.</li>' +
        '<li>Ships 2–4 business days after approval. Expedited 1–3 business days.</li>' +
        '<li>Email <a href="mailto:custom@customhoggtumblers.com">custom@customhoggtumblers.com</a> for assistance.</li>' +
      '</ul>',
      '<form id="tsd-customize-form" novalidate>',
      '<div class="tsd-customize__row">',
      '<label for="tsd-cq">' + (isCase ? 'Quantity (' + unitsPerQty + ' units each)' : 'Quantity') + ' *</label>',
      '<input type="number" id="tsd-cq" name="cart_quantity" min="1" step="1" value="1" required>',
      isCase ? '<p class="tsd-customize__hint" id="tsd-unit-hint"></p>' : '',
      '</div>',
      '<div class="tsd-customize__row">',
      '<label for="tsd-notes">Customization notes</label>',
      '<textarea id="tsd-notes" name="customization_notes" rows="3" placeholder="1 side with logo A, the other side with Smith Wedding 2026"></textarea>',
      '</div>',
      '<div class="tsd-customize__row">',
      '<label for="tsd-files">Artwork *</label>',
      '<input type="file" id="tsd-files" name="files" multiple required accept="' + acceptAttr + '">',
      '<p class="tsd-customize__hint">Up to ' +
        config.max_files +
        ' files, ' +
        Math.round(config.max_file_bytes / 1024 / 1024) +
        'MB each. ' +
        config.allowed_extensions.join(', ').toUpperCase() +
        '.</p>',
      '<p class="tsd-customize__hint">Need multiple designs? Add all files here and specify design details in customization notes.</p>',
      '</div>',
      '<p class="tsd-customize__error" id="tsd-customize-error" hidden></p>',
      '<div class="tsd-customize__actions">',
      '<button type="submit" class="button" id="tsd-customize-submit">Add to cart</button>',
      '<p class="tsd-customize__hint" style="text-align:right;">Your custom request is submitted after checkout.</p>',
      '</div>',
      '</form>',
      '<div class="tsd-customize__success" id="tsd-customize-success" hidden></div>',
      '</div>'
    ].join('');
    document.body.appendChild(modalEl);
    document.body.classList.add('tsd-customize-open');

    modalEl.querySelector('.tsd-customize__overlay').addEventListener('click', closeModal);
    modalEl.querySelector('.tsd-customize__close').addEventListener('click', closeModal);

    var qtyInput = modalEl.querySelector('#tsd-cq');
    var unitHint = modalEl.querySelector('#tsd-unit-hint');
    function updateUnitHint() {
      if (!unitHint) return;
      var qty = parseInt(qtyInput.value, 10) || 0;
      var units = qty * unitsPerQty;
      unitHint.textContent =
        qty + ' × ' + unitsPerQty + ' = ' + units + ' units of customization ($' + fee.price.toFixed(2) + '/unit, added at checkout).';
    }
    if (isCase) {
      qtyInput.addEventListener('input', updateUnitHint);
      updateUnitHint();
    }

    modalEl.querySelector('#tsd-customize-form').addEventListener('submit', function (e) {
      e.preventDefault();
      submitForm(product, pconf, config, fee);
    });
  }

  function showError(msg) {
    var el = modalEl.querySelector('#tsd-customize-error');
    el.textContent = msg;
    el.hidden = false;
  }

  function clearError() {
    var el = modalEl.querySelector('#tsd-customize-error');
    el.hidden = true;
    el.textContent = '';
  }

  function resetSubmitButton() {
    var submitBtn = modalEl.querySelector('#tsd-customize-submit');
    submitBtn.disabled = false;
    submitBtn.textContent = 'Add to cart';
  }

  function submitForm(product, pconf, config, fee) {
    clearError();
    var form = modalEl.querySelector('#tsd-customize-form');
    var submitBtn = modalEl.querySelector('#tsd-customize-submit');
    var cartQuantity = parseInt(form.cart_quantity.value, 10);
    var files = form.files.files;

    if (!cartQuantity || cartQuantity < 1) {
      showError('Quantity must be at least 1.');
      return;
    }
    if (!files || files.length < 1) {
      showError('Please attach at least one artwork file.');
      return;
    }
    if (files.length > config.max_files) {
      showError('Please attach no more than ' + config.max_files + ' files.');
      return;
    }
    for (var i = 0; i < files.length; i++) {
      var f = files[i];
      var ext = (f.name.split('.').pop() || '').toLowerCase();
      if (config.allowed_extensions.indexOf(ext) === -1) {
        showError('"' + f.name + '" is not an accepted file type.');
        return;
      }
      if (f.size > config.max_file_bytes) {
        showError('"' + f.name + '" is larger than the ' + Math.round(config.max_file_bytes / 1024 / 1024) + 'MB limit.');
        return;
      }
    }

    var unitCount = cartQuantity * pconf.units_per_qty;

    var formData = new FormData();
    formData.append('customer_email', '');
    formData.append('sku', product.sku);
    formData.append('variant_id', product.variant_id);
    formData.append('cart_quantity', String(cartQuantity));
    formData.append('unit_count', String(unitCount));
    formData.append('customization_notes', form.customization_notes.value.trim());
    for (var j = 0; j < files.length; j++) {
      formData.append('files[]', files[j]);
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting…';

    fetch(API_BASE + '/api/tsd-custom/requests', { method: 'POST', body: formData })
      .then(function (r) {
        return r.json().then(function (body) {
          return { ok: r.ok, body: body };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var msg = (result.body && result.body.error) || 'Something went wrong submitting your request. Please try again.';
          showError(msg);
          resetSubmitButton();
          return;
        }
        return addToCart(product, cartQuantity, unitCount, form, result.body, fee);
      })
      .catch(function () {
        showError('Something went wrong submitting your request. Please check your connection and try again.');
        resetSubmitButton();
      });
  }

  function addToCart(product, cartQuantity, unitCount, form, result, fee) {
    var notes = form.customization_notes.value.trim();
    var summary = notes ? notes : 'Custom order — see reference for details';

    var payload = {
      items: [
        {
          id: product.variant_id,
          quantity: cartQuantity,
          properties: {
            Customization: summary,
            Artwork: result.artwork_urls.length + ' file' + (result.artwork_urls.length === 1 ? '' : 's') + ' uploaded',
            _custom_ref: result.ref,
            _artwork_urls: result.artwork_urls.join(',')
          }
        },
        {
          id: fee.variant_id,
          quantity: unitCount,
          properties: {
            'Customization for': product.title,
            _custom_ref: result.ref,
            _tsd_fee_for: String(product.variant_id)
          }
        }
      ]
    };

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart add failed');
        return r.json();
      })
      .then(function () {
        showSuccess(result);
      })
      .catch(function () {
        showError(
          'Your customization request was saved (reference ' +
            result.ref +
            '), but adding it to your cart failed. Please contact us with this reference number so we can help.'
        );
        resetSubmitButton();
      });
  }

  function showSuccess(result) {
    var form = modalEl.querySelector('#tsd-customize-form');
    var success = modalEl.querySelector('#tsd-customize-success');
    form.hidden = true;
    success.hidden = false;
    var html =
      '<p>Added to your cart. Reference <strong>' +
      escapeHtml(result.ref) +
      '</strong>.</p>' +
      '<p>We’ll email you a proof before your order goes into production.</p>';
    if (result.failed_uploads && result.failed_uploads.length) {
      html +=
        '<p class="tsd-customize__warning">Note: ' +
        result.failed_uploads.map(escapeHtml).join(', ') +
        (result.failed_uploads.length === 1 ? ' did not upload.' : ' did not upload.') +
        ' Reply to your confirmation email if you’d like to resend ' +
        (result.failed_uploads.length === 1 ? 'it' : 'them') +
        '.</p>';
    }
    html += '<a class="button" href="' + window.Shopify.routes.root + 'cart">View Cart</a>';
    success.innerHTML = html;
  }

  // Cart-page/cart-guard logic (fee-line thumbnail, mug/fee quantity sync) moved
  // to the sitewide assets/tsd-cart-guard.js -- see that file for why. This file
  // stays scoped to just the button + modal on customization-enabled product pages.

  document.addEventListener('DOMContentLoaded', function () {
    initButton();
  });
})();
